import { BaseModal } from "../../../../../components/common/BaseModal/BaseModal";
import { useUiTranslator } from "../../../../../hooks/useUiTranslator";

import { ReactNode, useMemo, useState } from "react";

import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
} from "@mui/material";

export const DisclaimerApplicationConfigurator = (): ReactNode => {
  const t = useUiTranslator();
  const hideModal = useMemo(
    () => localStorage.getItem("hideAppConfDisclaimer") || "false",
    [],
  );

  const [isOpen, setIsOpen] = useState<boolean>(
    hideModal === "true" ? false : true,
  );
  const handleClose = (): void => {
    setIsOpen(false);
  };

  const setShouldOpen = (value: boolean): void => {
    localStorage.setItem("hideAppConfDisclaimer", value ? "true" : "false");
  };

  return (
    <>
      <BaseModal
        isOpen={isOpen}
        onClose={handleClose}
        title={t(
          "CustomApp:disclaimer.AppConf.Headline",
          "Welcome to the WEG Application Calculator",
        )}
        customSx={{ maxWidth: "50rem", px: 4 }}
      >
        <Box>
          <Box>
            <Typography variant="body1">
              {t(
                "CustomApp:disclaimer.AppConf.Body",
                "Quickly identify the right WEG drive solution for your application. Enter your operating data and explore tailored product suggestions. If needed, you can refine the details later in the WEG Configurator.",
              )}
            </Typography>
            <Box mt={2} display="flex" flexDirection="column">
              <Typography variant="caption">
                {t("CustomApp:disclaimer.AppConf.NoteHeadline", "Note:")}
              </Typography>
              <Typography variant="caption">
                {t(
                  "CustomApp:disclaimer.AppConf.NoteBody",
                  "This calculator is intended to support your initial product selection by providing a quick overview based on basic application data and catalogue criteria. It does not replace detailed engineering validation. For complex requirements, special conditions, or if you are unsure about the results, please contact WEG's technical team for personalized support. Final product suitability must always be confirmed in collaboration with our experts.",
                )}
              </Typography>
            </Box>
          </Box>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            mt={2}
            gap={1}
          >
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    defaultChecked={hideModal === "true"}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      setShouldOpen(event.currentTarget.checked);
                    }}
                  />
                }
                label={
                  <Typography variant="caption">
                    {t(
                      "CustomApp:label.dontShowAgain",
                      "Don't show this again",
                    )}
                  </Typography>
                }
              />
            </FormGroup>
            <Button variant="contained" onClick={handleClose}>
              {t("CustomApp:button.confirm", "Ok")}
            </Button>
          </Box>
        </Box>
      </BaseModal>
    </>
  );
};
